<div class="code">{{ error().code }}</div>
<div class="info">
  <div class="message">{{ error().message }}</div>
  <div class="details" [innerHTML]="error().details"></div>
  <div class="actions">
    @for (action of error().actions; track action.title) {
      <button type="button" mat-button class = "accent-color" (click)="action.handler()">
        {{ action.title }}
      </button>
    }
  </div>
</div>
